<template>
    <b-modal id="modal-sukses" title="Sukses" centered
        no-close-on-backdrop no-close-on-esc hide-header-close
        ok-only ok-title="OK" @ok="$emit('done')"  auto-focus-button="ok"
    >
        Data gadai berhasil disimpan! Silahkan melanjutkan proses ke kasir.
        <br /><br />
        No. Faktur:
        <h3 class="font-weight-bold">{{ rincian.noFaktur }}</h3>
    </b-modal>
</template>

<script>
export default {
    name: 'modal-sukses',
    props: {
        rincian: { type: Object, required: true }
    },
}
</script>